export default __webpack_public_path__ + "static/media/Asus PB287Q.f556b30d.png";